<template>
    <div class="mt-4">
        <h3 class="mb-2 text-lg">{{ title }} Signature</h3>
        <canvas class="bg-white border border-black" width="300" height="200" ref="signature"></canvas>
        <ValidationProvider tag="div" name="Signature Image" rules="required" v-slot="{ errors }">
            <span class="text-xs block mb-2 text-red-500 mt-1" v-if="errors[0]">{{ errors[0] }}</span>
            <button
                type="button"
                @click="clearSignature"
                class="mt-2 text-xs text-blue-500 hover:text-blue-400 hover:underline transition duration-300"
            >
                Clear Signature
            </button>
            <input type="hidden" v-model="model.signature_image" ref="signatureCheck" />
        </ValidationProvider>
        <div class="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <ValidationProvider tag="div" name="Signature" rules="required" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">Print Name</label>
                <input class="text-sm" :class="{ 'border-red-500': errors[0] }" type="text" v-model="model.signature" />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div" name="Date" rules="required" class="flex flex-col" v-slot="{ errors }">
                <label for="" class="text-gray-600 block text-xs mb-1">Date</label>
                <input
                    readonly
                    class="text-sm bg-gray-200"
                    :class="{ 'border-red-500': errors[0] }"
                    type="text"
                    :value="date"
                />
                <span class="text-xs text-red-500 mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
import SignaturePad from 'signature_pad';
export default {
    props: ["title", "model"],
    data() {
        return {
            signaturePad: null,
            signatureImage: null
        };
    },
    mounted() {
        const canvas = this.$refs.signature;
        if (canvas) {
            this.signaturePad = new SignaturePad(canvas, {
                onEnd: () => {
                    this.$emit('signatureUpdated', this.signaturePad.toDataURL());
                }
            });
        }
    },
    methods: {
        clearSignature() {
            this.signaturePad.clear();
            this.$emit('signatureUpdated', null);
        }
    },
    computed: {
        date() {
            return new Date().toLocaleDateString('en-GB')
        }
    }
};
</script>

<style>
</style>